import * as React from "react";
import { IPatientContactedTreatmentModel, IPatientContactedTreatmentListItem } from "../../../../models/IPatientContactedTreatment";
import { CustomButton, ButtonType, Table, AlertMessage, AlertType } from "soprasteria-ui-library";
import { useAuth } from "../../../../App";
import { dateTimeToDateString } from "../../../../helpers/DateHelper";
import { PatientContactedTreatmentModal } from "../Modals/PatientContactedTreatmentModal";
import { PatientContactedTreatmentApi } from "../../../../api/PatientContactedTreatmentApi";

interface IPatientContactedTreatmentTab {
    patientContactedTreatment: IPatientContactedTreatmentModel;
    patientId: number;
    reloadData: () => void;
}

export const PatientContactedTreatmentTab: React.FunctionComponent<IPatientContactedTreatmentTab> = ({ patientContactedTreatment, patientId, reloadData }) => {
    const auth = useAuth();
    const api = new PatientContactedTreatmentApi(auth);
    const [errorMessage, setErrorMessage] = React.useState<string>("");
    const [patientContactedTreatmentToEdit, setPatientContactedTreatmentToEdit] = React.useState<IPatientContactedTreatmentListItem>();
    const [renderModal, setRenderModal] = React.useState<boolean>(false);
    const [isDeletingPatientContactedTreatment, setIsDeletingPatientContactedTreatment] = React.useState<boolean>(false);
    const [deletingPatientContactedTreatmentId, setDeletingPatientContactedTreatmentId] = React.useState<number>();
    
    const onSubmittedPatientContactedTreatmentSuccess = () => {
        closeModal();
        reloadData();
    }

    const closeModal = () => {
        setRenderModal(false);
        setPatientContactedTreatmentToEdit(undefined);
    }

    const onClickedRow = (patientContactedTreatment: IPatientContactedTreatmentListItem) => {
        setRenderModal(true);
        setPatientContactedTreatmentToEdit(patientContactedTreatment);
    }

    const deletePatientContactedTreatment = (patientContactedTreatmentId: number) => {
        const accepted = window.confirm("Är du säker på att du vill ta bort rapport om kontaktad patient?");
        if (accepted) {
            setIsDeletingPatientContactedTreatment(true);
            setDeletingPatientContactedTreatmentId(patientContactedTreatmentId);
            api.deletePatientContactedTreatment(patientContactedTreatmentId, () => {
                reloadData();
            }, (error) => {
                setErrorMessage(error);
            }, () => {
                setDeletingPatientContactedTreatmentId(undefined);
                setIsDeletingPatientContactedTreatment(false)
            });
        }
    }

    return (
        <section>
            {
                renderModal ?
                    <PatientContactedTreatmentModal
                        onSave={onSubmittedPatientContactedTreatmentSuccess}
                        patientId={patientId}
                        patientContactedTreatmentToEdit={patientContactedTreatmentToEdit}
                        onCloseModal={closeModal}
                    />
                    : null
            }
            <AlertMessage alertType={AlertType.danger}>{errorMessage}</AlertMessage>
            {
                patientContactedTreatment.canCreatePatientContactedTreatment ?
                    <div className="panel text-right">
                        <CustomButton buttonType={ButtonType.create} buttonText="Skapa rapport om kontaktad patient" data-toggle="modal" data-target="#patient-contacted-treatment-modal" onClick={() => setRenderModal(true)} />
                    </div>
                    : null
            }
            <input type="hidden" data-toggle="modal" id="open-modal" data-target="#create-emergency-treatment-modal" />
            
            <Table hoverableRows>
                <thead>
                    <tr>
                        <th>Mottagning</th>
                        <th>Kontaktad datum</th>
                        <th>Skapad</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        patientContactedTreatment.patientContactedTreatments.length > 0
                            ? patientContactedTreatment.patientContactedTreatments.map((patientContactedTreatment, key) => {
                                return (
                                    <tr key={key} className="clickable-row">
                                        <td onClick={() => onClickedRow(patientContactedTreatment)}>{patientContactedTreatment.careProvider.displayCareProviderName }</td>
                                        <td onClick={() => onClickedRow(patientContactedTreatment)}>{dateTimeToDateString(patientContactedTreatment.contactedDate)}</td>
                                        <td onClick={() => onClickedRow(patientContactedTreatment)}>{dateTimeToDateString(patientContactedTreatment.createdDate)}</td>
                                        <td className="delete-btn">
                                            {
                                                patientContactedTreatment.canBeDeleted ?
                                                    <CustomButton
                                                        buttonType={ButtonType.delete}
                                                        buttonText=""
                                                        onClick={() => deletePatientContactedTreatment(patientContactedTreatment.patientContactedTreatmentId)}
                                                        isLoading={isDeletingPatientContactedTreatment && deletingPatientContactedTreatmentId === patientContactedTreatment.patientContactedTreatmentId}
                                                        />
                                                    : null
                                            }
                                        </td>
                                    </tr>
                                )
                            })
                            : <tr><td colSpan={4}>Det finns inga patientkontakter</td></tr>
                    }
                </tbody>
            </Table>
        </section>
    );
}